import { retrieveItem } from '@flexera/lib.setting-storage';

export const getRecentSearches = async (orgId: string) => {
	const savedRecentSearches = await retrieveItem({
		key: 'recent-searches',
		orgId
	});
	return savedRecentSearches;
};
